/**
 * 業務マップ（F1）のルートパス定義。
 *
 * Epic と業務は一覧を持たない。業務マップ（`BUSINESS_MAP_ROUTE`）が Epic │ ストーリー │
 * 業務 │ 処理 の 4 レーンで全件を出しており、平らな一覧を別に切ると同じ集合が 2 箇所に並ぶ。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 業務マップのルートパスを定義する。
 * @graph-connects none
 */
import type { FeatureRouteSets } from './feature-route-sets.js';

/**
 * 業務マップ —Epic │ ストーリー │ 業務 │ 処理 のレーン列（作り直しの要素表を読む）。
 *
 * **旧の業務ツリー（`/epics`）と業務の一覧（`/businesses`）を畳んだ先である。** 旧の 2 本は
 * Epic の木と業務の平らな並びを別々に描いており、同じ仕様の集合が 2 つの入口に分かれていた。
 * 4 レーンは同じ集合を 1 画面に載せて左から右へ絞る形なので、入口を 2 つ持つ理由が無くなる。
 *
 * **パスは概念に合わせる。** 置き場所の都合で付けた `/overview` ではなく、画面が描く概念
 * （業務のマップ）をそのまま綴る。`/overview` は誰にも配っていない URL なので、倒す先を
 * 残さずに消す。
 * @graph-connects none
 */
export const BUSINESS_MAP_ROUTE = '/business-map';

/** 業務マップのルートの集合。案件を検索条件で受ける。 @graph-connects none */
export const businessMapRouteSets = {
  all: [BUSINESS_MAP_ROUTE],
  pjSearch: [BUSINESS_MAP_ROUTE],
  operationSearch: [],
  pjPath: [],
} as const satisfies FeatureRouteSets;
